import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Tooltip } from '../tooltip/tooltip';
import { Button } from './button';
export const TooltipButton = ({ buttonText, disabledButton, disabledTooltip, onClick, style, tooltipMessage, tooltipPlacement, variant = 'primary', width, }) => {
    const [showToolTip, setShowToolTip] = useState(false);
    useEffect(() => {
        if (disabledButton || disabledTooltip)
            setShowToolTip(false);
    }, [disabledButton, disabledTooltip]);
    return (_jsx(Tooltip, { message: tooltipMessage, showTooltip: showToolTip && !disabledButton && !disabledTooltip, placement: tooltipPlacement, offsetValue: 35, width: width, children: _jsx(Button, { onMouseEnter: () => setShowToolTip(true), onMouseLeave: () => setShowToolTip(false), disabled: disabledButton, onClick: onClick, variant: variant, style: style, children: buttonText }) }));
};
//# sourceMappingURL=tooltip_button.js.map